import apiClient from '@/services/api'

const getAccrualError = error => error?.response?.data ?? error?.message ?? error

const throwResponseError = data => {
  if (data?.error_code && data.error_code !== '0') {
    throw data
  }
}

const throwGroupResponseError = data => {
  if (data?.error_code && data.error_code !== '0') {
    throw new Error(data.msg)
  }
}

export default {
  async getAccrualGroups() {
    try {
      const { data } = await apiClient.get('/api/accrual/groups')
      throwGroupResponseError(data)
      return data.items ?? []
    } catch (error) {
      throw getAccrualError(error)
    }
  },
  async postAccrualGroup({ rootState }, payload) {
    try {
      const { data } = await apiClient.post('/api/accrual/groups', {
        ...payload,
        project_id: rootState.applicationState.currentProject.id
      })
      throwGroupResponseError(data)
      return data
    } catch (error) {
      throw getAccrualError(error)
    }
  },
  async patchAccrualGroup({ rootState }, { group_id, payload }) {
    try {
      const { data } = await apiClient.patch(`/api/accrual/groups/${group_id}`, {
        ...payload,
        project_id: rootState.applicationState.currentProject.id
      })
      throwGroupResponseError(data)
      return data
    } catch (error) {
      throw getAccrualError(error)
    }
  },
  async deleteAccrualGroup(_, { group_id }) {
    try {
      const { data } = await apiClient.delete(`/api/accrual/groups/${group_id}`)
      throwGroupResponseError(data)
    } catch (error) {
      throw getAccrualError(error)
    }
  },
  async postAccrualGroupVersion({ rootState }, payload) {
    try {
      const { data } = await apiClient.post('/api/accrual/group_versions', {
        ...payload,
        project_id: rootState.applicationState.currentProject.id
      })
      throwGroupResponseError(data)
      return data
    } catch (error) {
      throw getAccrualError(error)
    }
  },
  async patchAccrualGroupVersion({ rootState }, { version_id, payload }) {
    try {
      const { data } = await apiClient.patch(`/api/accrual/group_versions/${version_id}`, {
        ...payload,
        project_id: rootState.applicationState.currentProject.id
      })
      throwGroupResponseError(data)
      return data
    } catch (error) {
      throw getAccrualError(error)
    }
  },
  async cloneAccrualGroupVersion({ rootState }, { version_id }) {
    try {
      const { data } = await apiClient.post(`/api/accrual/group_versions/${version_id}/clone`, {
        project_id: rootState.applicationState.currentProject.id
      })
      throwGroupResponseError(data)
      return data
    } catch (error) {
      throw getAccrualError(error)
    }
  },
  async previewAccrualGroupVersion(_, { version_id }) {
    try {
      const { data } = await apiClient.get(`/api/accrual/group_versions/${version_id}/preview`)
      throwGroupResponseError(data)
      return data
    } catch (error) {
      throw getAccrualError(error)
    }
  },
  async applyAccrualGroupVersion({ rootState }, { version_id }) {
    try {
      const { data } = await apiClient.post(`/api/accrual/group_versions/${version_id}/apply`, {
        project_id: rootState.applicationState.currentProject.id
      })
      throwGroupResponseError(data)
      return data
    } catch (error) {
      throw getAccrualError(error)
    }
  },
  async getAccrualBalances(_, { associate_id }) {
    try {
      const { data } = await apiClient.get('/api/accrual/balances', { params: { associate_id } })
      throwResponseError(data)
      return data.items ?? []
    } catch (error) {
      throw getAccrualError(error)
    }
  },
  async adjustAccrualBalance({ rootState }, { action, payload }) {
    try {
      const { data } = await apiClient.post(`/api/accrual/adjustments/${action}`, {
        ...payload,
        project_id: rootState.applicationState.currentProject.id
      })
      throwResponseError(data)
      return data
    } catch (error) {
      throw getAccrualError(error)
    }
  },
  async quotePayCode(_, payload) {
    try {
      const { data } = await apiClient.post('/api/accrual/pay_code/quote', payload)
      throwResponseError(data)
      return data
    } catch (error) {
      throw getAccrualError(error)
    }
  },
  async quotePayCodes(_, payload) {
    try {
      const { data } = await apiClient.post('/api/accrual/pay_code/quotes', payload)
      throwResponseError(data)
      return data.items ?? []
    } catch (error) {
      throw getAccrualError(error)
    }
  }
}
